import api from "../../../helpers/axios";

class FacilityThemeServiceV2 {
  async getFacilityThemeById(facilityNumber) {
    const response = await api.get(`/facility_theme/${facilityNumber}`);
    return response?.data;
  }

  async createFacilityTheme(facilityThemeData) {
    const response = await api.post("/facility_theme/", facilityThemeData);
    return response.data;
  }

  async updateFacilityTheme(facilityNumber, configData) {
    const response = await api.patch(`/facility_theme/${facilityNumber}`, configData);
    return response.data;
  }
}

export default new FacilityThemeServiceV2();
